export default __webpack_public_path__ + "static/media/iconeEnergia2.3f908784.png";